import axios from "axios";
import { getData } from "src/utils/localDataHandler";
//import AxiosMockAdapter from 'axios-mock-adapter';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:3000/'
  baseURL: process.env.REACT_APP_API,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error?.response?.status === 401) {
    //   return window.location.href = '/logout'
    // }
    return Promise.reject(
      (error?.response && error?.response?.data) || "Something went wrong"
    );
  }
);

axiosInstance.interceptors.request.use(function (config) {
  const bkv_token = getData("bkv_token");
  if (bkv_token) {
    config.headers.bkv_token = bkv_token;
  }
  return config;
});

// export const mock = new AxiosMockAdapter(axiosInstance, { delayResponse: 0 });

export default axiosInstance;
